import { DATE_US, formatDate } from '@koob/dates';

export default function BookingSummaryCard({ title, startAt, endAt, pax }) {
  const hasInfo = startAt || endAt || pax > 0;

  if (!title && !hasInfo) return null;

  return (
    <>
      {title && (
        <div className="text-gray-800 text-xl font-medium text-center">
          {title}
        </div>
      )}

      {hasInfo && (
        <div className="flex flex-col items-center gap-1 text-base text-gray-500 border-t border-b border-gray-100 py-2">
          {(startAt || endAt) && (
            <div className="flex items-center gap-2">
              <i className="far fa-calendar" />
              <span>
                {startAt && formatDate(startAt, DATE_US)}
                {startAt && endAt && ' → '}
                {endAt && formatDate(endAt, DATE_US)}
              </span>
            </div>
          )}

          {pax > 0 && (
            <div className="flex items-center gap-2">
              <i className="far fa-users" />
              <span>{pax} pax</span>
            </div>
          )}
        </div>
      )}
    </>
  );
}
